import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import logo from './logo/phishLogo.png';

const NewUserNavBar = () => {
  //--------AppBar styles------//
  const useStyles = makeStyles((theme) => ({
    appBar: {
      //backgroundColor: '#fafafa',
      boxShadow: 'none',
      backgroundColor: theme.palette.background.default,
      //zIndex: theme.zIndex.drawer + 1,
    },
    title: {
      display: 'block',
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.grow}>
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.appBar} style={{ position: 'fixed', width: '100%' }}>
          <Typography className={classes.title} variant="h6" noWrap>
            <img id="navbarLogo" src={logo} alt="Logo" />
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  );
};
export default NewUserNavBar;
